const dateLocal = require('./dateLocal'),
    timeLocal = require('./timeLocal');

module.exports = function (dateTime) {
    if (!dateTime) {
        return null;
    }
    return `${dateLocal(dateTime)} ${timeLocal(dateTime)}`;
};
